import React, { useState } from "react";
import cn from "classnames";

import { Carousel as ACarousel, CarouselProps } from "antd";
import Icon from "@ant-design/icons";

import { ReactComponent as LeftArrow } from "assets/icons/carousel-left-arrow.svg";
import { ReactComponent as RightArrow } from "assets/icons/carousel-right-arrow.svg";

import "./Carousel.scss";

type Props = CarouselProps & {
  onChange?: (index: number) => void;
};

export const Carousel: React.FC<Props> = React.memo(
  ({ children, onChange, ...rest }) => {
    const [activeDot, setActiveDot] = useState(0);
    const playSpeed = 20000;
    const handleChange = (_: number, value: number) => {
      onChange?.(value);
      setActiveDot(value);
    };


    return (
      <ACarousel
        arrows
        effect="fade"
        autoplay={true}
        autoplaySpeed={playSpeed}
        adaptiveHeight={true}
        dots={{ className: cn(["carousel-dots", `active-dot-${activeDot}`]) }}
        prevArrow={<Icon component={LeftArrow} style={{ fontSize: "2rem" }} />}
        nextArrow={<Icon component={RightArrow} style={{ fontSize: "2rem" }} />}
        beforeChange={handleChange}
        {...rest}
      >
        {children}
      </ACarousel>
    );
  }
);
